import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { HeaderComponent } from './header/header.component';
import { RequiredLabelComponent } from './required-label/required-label.component';
import { SgzpApp2ChangePasswordSentComponent } from './sgzp-app2-change-password-sent/sgzp-app2-change-password-sent.component';
import { SgzpApp2DxsalesLoginComponent } from './sgzp-app2-dxsales-login/sgzp-app2-dxsales-login.component';
import { SgzpApp2ForgotPasswordComponent } from './sgzp-app2-forgot-password/sgzp-app2-forgot-password.component';
import { SgzpApp2InputComponent } from './sgzp-app2-input/sgzp-app2-input.component';
import { SgzpApp2KanriLoginComponent } from './sgzp-app2-kanri-login/sgzp-app2-kanri-login.component';
import { SgzpApp2LoginComponent } from './sgzp-app2-login/sgzp-app2-login.component';
import { SgzpApp2PasswordInputAnimatedComponent } from './sgzp-app2-password-input-animated/sgzp-app2-password-input-animated.component';
import { SgzpApp2PasswordInputComponent } from './sgzp-app2-password-input/sgzp-app2-password-input.component';
import { SgzpApp2RegisterResendComponent } from './sgzp-app2-register-resend/sgzp-app2-register-resend.component';
import { SgzpApp2RegisterSendComponent } from './sgzp-app2-register-send/sgzp-app2-register-send.component';
import { SgzpApp2ResetPasswordComponent } from './sgzp-app2-reset-password/sgzp-app2-reset-password.component';
import { SgzpApp2UnblockComponent } from './sgzp-app2-unblock/sgzp-app2-unblock.component';
import {
  ModalComponent,
  SgzpApp2Component,
} from './sgzp-app2/sgzp-app2.component';

@NgModule({
  declarations: [
    SgzpApp2LoginComponent,
    SgzpApp2Component,
    SgzpApp2RegisterSendComponent,
    SgzpApp2RegisterResendComponent,
    SgzpApp2ResetPasswordComponent,
    SgzpApp2ForgotPasswordComponent,
    SgzpApp2UnblockComponent,
    SgzpApp2InputComponent,
    SgzpApp2ChangePasswordSentComponent,
    SgzpApp2PasswordInputComponent,
    SgzpApp2DxsalesLoginComponent,
    SgzpApp2KanriLoginComponent,
    RequiredLabelComponent,
    HeaderComponent,
    SgzpApp2PasswordInputAnimatedComponent,
    ModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    MatDialogModule,
  ],
  providers: [DatePipe],
  exports: [
    SgzpApp2LoginComponent,
    SgzpApp2Component,
    SgzpApp2RegisterSendComponent,
    SgzpApp2RegisterResendComponent,
    SgzpApp2ResetPasswordComponent,
    SgzpApp2ForgotPasswordComponent,
    SgzpApp2UnblockComponent,
    SgzpApp2InputComponent,
    SgzpApp2ChangePasswordSentComponent,
  ],
})
export class SgzpApp2Module {}
